// https://nehalist.io/angular-7-models/#modelsanddeserialization
// https://nehalist.io/working-with-models-in-angular/#deserialization
import { forkJoin, Observable, of } from 'rxjs';
import * as rxsync from '@ivlasov/rxsync';
import { map, tap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { LodashService } from '../shared/services/lodash.service';
import { GoogleService } from '../shared/services/google.service';
import { CbrService } from '../shared/services/cbr.service';
import { EfoElevateService } from '../shared/services/elevate.service';
import { EfoYellowPagesService } from '../shared/services/yellowpages.service';
import { EfoSdbService } from '../shared/services/sdb.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DealerService {
  public lookups: any;
  public typeLookups: any = {};

  constructor(
    private efoLd: LodashService,
    private efoGoogle: GoogleService,
    private efoCbr: CbrService,
    private efoElevate: EfoElevateService,
    private efoYp: EfoYellowPagesService,
    private efoSdb: EfoSdbService,
    private http: HttpClient,
  ) {
    //this.getTypeLookups();
    this.efoCbr.brandMarketShare().subscribe((rs) => {
      rs = _.sortBy(rs, 'brand');
      this.dealerMakes = rs;
      this.selectOptions.carManufacturers = _.map(rs, (d) => {
        return { label: d.brand_name, value: d.brand };
      });
    });
  }

  getCampaignsO(account_num: string): Observable<any> {
    return this.http.get(
      `${environment.nestElevationApiUrl}/sdb/activeCampaigns/${account_num}`,
    );
  }

  selectOptions: any = {
    customerLevel: [
      {
        label: '',
        value: '',
      },
      {
        label: 'POS',
        value: 'pos',
      },
    ],
    associatedWith: [
      {
        label: '',
        value: '',
        code: '',
      },
      {
        label: 'Penske Group',
        value: 'penske',
        code: 'P',
      },
      {
        label: 'AutoNation Inc.',
        value: 'autonation',
        code: '',
      },
      {
        label: 'Lithia Motors',
        value: 'lithia',
        code: '',
      },
      {
        label: 'Group 1',
        value: 'group1',
        code: '',
      },
      {
        label: 'Sonic Automotive',
        value: 'sonic',
        code: '',
      },
      {
        label: 'Hendrick Group',
        value: 'hendrick',
        code: '',
      },
      {
        label: 'Asbury Group',
        value: 'asbury',
        code: '',
      },
      {
        label: 'Larry H. Miller',
        value: 'larryhmiller',
        code: '',
      },
      {
        label: 'Ken Garff Group',
        value: 'kengarff',
        code: '',
      },
      {
        label: 'Staluppi Group',
        value: 'staluppi',
        code: '',
      },
    ],
    isActive: [
      {
        label: '',
        value: '',
        code: '',
      },
      {
        label: 'Active',
        value: 1,
        code: '',
      },
      {
        label: 'Inactive',
        value: 0,
        code: '',
      },
    ],
    yesNo: [
      {
        label: '',
        value: '',
        code: '',
      },
      {
        label: 'Yes',
        value: 'yes',
        code: '',
      },
      {
        label: 'No',
        value: 'no',
        code: '',
      },
    ],
    dmsVendors: [
      {
        label: '',
        value: '',
        code: '',
      },
      {
        label: 'Advent',
        value: 'advent',
        code: '',
      },
      {
        label: 'AutoMate',
        value: 'automate',
        code: '',
      },
      {
        label: 'AutoSoft',
        value: 'autosoft',
        code: '',
      },
      {
        label: 'CDK',
        value: 'cdk',
        code: '',
      },
      {
        label: 'CDK Drive',
        value: 'cdkdrive',
        code: '',
      },
      {
        label: 'DealerTrack',
        value: 'dealertrack',
        code: '',
      },
      {
        label: 'DealerVault',
        value: 'dealervault',
        code: '',
      },
      {
        label: 'Reynolds & Reynolds',
        value: 'reyrey',
        code: '',
      },
      {
        label: 'Tekion - FTP',
        value: 'tekion',
        code: '',
      },
      {
        label: 'Tekion - API',
        value: 'tekion-api',
        code: '',
      },
    ],
    crmVendors: [
      {
        label: '',
        value: '',
        code: '',
      },
      {
        label: 'CDK eLeads',
        value: 'eleads',
        code: '',
      },
      {
        label: 'DealerPeak',
        value: 'dealerpeak',
        code: '',
      },
      {
        label: 'DealerMine',
        value: 'dealermine',
        code: '',
      },
      {
        label: 'DealerSocket',
        value: 'dealersocket',
        code: '',
      },
      {
        label: 'Dominion',
        value: 'dominion',
        code: '',
      },
      {
        label: 'DriveCentric',
        value: 'drivecentric',
        code: '',
      },
      {
        label: 'Reynolds & Reynolds',
        value: 'reyrey',
        code: '',
      },
      {
        label: 'Tekion - API',
        value: 'tekion-api-crm',
        code: '',
      },
      {
        label: 'VIN Solutions',
        value: 'vinsolutions',
        code: '',
      },
      {
        label: 'Unknown',
        value: 'unknown',
        code: '',
      },
    ],
    carManufacturers: [],
    dealer_tiers: [],
    web_providers: [],
  };

  public dealerManufacturers = [
    'cadillac',
    'audi',
    'jaguar',
    'landrover',
    'porsche',
    'fiat',
    'genesis',
    'infiniti',
    'lincoln',
    'ram',
    'volkswagen',
    'mini',
    'honda',
    'lexus',
    'mazda',
    'toyota',
    'hyundai',
    'chrysler',
    'jeep',
    'dodge',
    'subaru',
    'bmw',
    'mercedes',
    'gmc',
    'chevy',
    'mitsubishi',
    'buick',
    'acura',
    'ford',
    'nissan',
    'kia',
    'used',
  ];
  public dealerMakes: any = [];

  getTypeLookups(callback?): void {
    this.efoSdb.getTypeLookups().subscribe((rs) => {
      this.typeLookups = rs;
      this.lookups = _.reduce(
        rs,
        function (o, d, k) {
          let kk = k != 'dms' ? k + '_type_key' : k + 'type_key';
          o[k] = _.keyBy(d, kk);
          return o;
        },
        {},
      );
      if (_.isFunction(callback)) {
        callback();
      }
    });
  }

  public formValues = {
    included_solutions: [],
    specialized_targeting: [],
    campaign_types: [],
    startDate: { month: null, day: null, year: null },
    endDate: { month: null, day: null, year: null },
    egi: {
      startDate: { month: null, day: null, year: null },
      endDate: { month: null, day: null, year: null },
    },
  };
  makeProspectAccountNum() {
    return 'P' + (Math.floor(Math.random() * 9000000) + 90000000);
  }

  public vehicleExtractors: any = [];
  getVehicleExtractors(callback?) {
    this.efoElevate.vehicleExtractors().subscribe((rs) => {
      this.vehicleExtractors = rs;
      if (_.isFunction(callback)) {
        callback(null);
      }
    });
  }
  testWebProvider(callback?) {}
  mainBodyHtml: string = '';
  htmlLoadMain: boolean = false;
  getDealerWebsiteInfo(ypDealer): Observable<any> {
    //$scope.urlPreview = 'http://'+$scope.dealer.website;
    this.htmlLoadMain = false;
    return this.efoElevate.getHtml('http://' + ypDealer.url, 'body').pipe(
      map((rs) => {
        if (!_.has(rs, 'html')) {
          return;
        }
        //so jquery doesn't try to load the images
        rs.html[0] = rs.html[0].replace(/src=/gi, 'tempSrc=');
        this.mainBodyHtml = rs.html[0];

        this.htmlLoadMain = true;
        //this.testWebProvider();
        //test each of the web providers
        _.each(this.vehicleExtractors, (d) => {
          var isWebProvider =
            this.mainBodyHtml.indexOf(d.provider_checker) != -1;
          d.provider_checker_result = isWebProvider;
          if (isWebProvider) {
            ypDealer.extractor = _.find(this.vehicleExtractors, {
              extractor_uuid: d.extractor_uuid,
            });
            ypDealer.webProvider = ypDealer.extractor.extractor.split('.')[0];
            $('.logo img', '<html>' + rs.html[0] + '</html>');
            if (
              false &&
              _.has(d, 'extractor') &&
              d.extractor == 'dealerinspire2020'
            ) {
              //lazy-load img extraction - dealerinspire2020
              ypDealer.logoUrl = $(
                '.dealerLogo noscript',
                '<html>' + rs.html[0] + '</html>',
              )[0]
                .textContent.toString()
                .match(/tempSrc="(.+?)"/)[1];
            } else {
              ypDealer.logoUrl = $(
                $(
                  '.logo img, .dealerLogo img',
                  '<html>' + rs.html[0] + '</html>',
                )[0],
              ).attr('tempSrc');
            }
            ypDealer.logoUrl =
              !_.isUndefined(ypDealer.logoUrl) &&
              ypDealer.logoUrl.indexOf('http') == -1
                ? 'http://' + ypDealer.url + ypDealer.logoUrl
                : ypDealer.logoUrl;
            this.getInventoryCount(ypDealer);
          }
        });
        return ypDealer;
      }),
    );
  }

  getInventoryCount(ypDealer): void {
    let extractor = ypDealer.extractor;
    let prelim_extraction = {
      new_count: null,
      per_page_new: null,
      used_count: null,
      per_page_used: null,
    };
    forkJoin([
      this.efoElevate
        .getHtml(
          'https://' + ypDealer.url + extractor.start_urls[0].start_url,
          'body',
        )
        .pipe(
          tap((rs1) => {
            //so jquery doesn't try to load the images
            rs1.html[0] = rs1.html[0].replace(/src=/gi, 'tempSrc=');
            let newBodyHtml = rs1.html[0];
            prelim_extraction.new_count = (<any>(
              jQuery(extractor.count_selector, newBodyHtml)
            )).text();
            // @ts-ignore
            prelim_extraction.per_page_new = (<any>(
              jQuery(extractor.per_page_selector, newBodyHtml)
            )).length;
          }),
        ),
      this.efoElevate
        .getHtml(
          'https://' + ypDealer.url + extractor.start_urls[1].start_url,
          'body',
        )
        .pipe(
          tap((rs2) => {
            //so jquery doesn't try to load the images
            rs2.html[0] = rs2.html[0].replace(/src=/gi, 'tempSrc=');
            let usedBodyHtml = rs2.html[0];
            prelim_extraction.used_count = (<any>(
              jQuery(extractor.count_selector, usedBodyHtml)
            )).text();
            prelim_extraction.per_page_used = (<any>(
              jQuery(extractor.per_page_selector, usedBodyHtml)
            )).length;
          }),
        ),
    ]).subscribe(([rs1, rs2]) => {
      ypDealer.prelim_extraction = prelim_extraction;
      ypDealer.new_count = prelim_extraction.new_count.replace(/\D/g, '');
      ypDealer.used_count = prelim_extraction.used_count.replace(/\D/g, '');
    });
  }
  getDistanceFrom = (loc1, loc2) => {
    return this.efoGoogle.distFrom(
      loc2.latitude,
      loc2.longitude,
      loc1.latitude,
      loc1.longitude,
    );
  };
  getGoogleInfo(ypDealer, callback?): void {
    this.efoCbr.getGoogleInfo(ypDealer.dealer_uuid).subscribe((rs) => {
      _.extend(ypDealer, rs);
    });
    return;
    this.efoCbr.getGoogleInfo(ypDealer.dealer_uuid).subscribe((rs) => {
      if (!_.isEmpty(rs[0].google_info)) {
        ypDealer.googleResult = rs[0].google_info;
        ypDealer.googleRating = ypDealer.googleResult.rating;
        ypDealer.googleTotalUserRatings =
          ypDealer.googleResult.user_ratings_total;
        if (
          _.has(ypDealer, 'googleResult.photos') &&
          ypDealer.googleResult.photos.length > 0
        ) {
          ypDealer.dealerPhotoUrl =
            'https://maps.googleapis.com/maps/api/place/photo?photoreference=' +
            ypDealer.googleResult.photos[0].photo_reference +
            '&sensor=false&maxheight=240&maxwidth=640&key=AIzaSyAzRlpb4MbISc_8JRIF8TIqgsrQEjOdv14';
        }
      } else {
        ypDealer.googleRating = 'N/A';
        ypDealer.googleTotalUserRatings = 'N/A';
      }
      if (_.isFunction(callback)) {
        callback(null, ypDealer);
      }
    });
    return;
    this.efoYp
      .getGoogleDealers({
        latitude: ypDealer.latitude,
        longitude: ypDealer.longitude,
      })
      .subscribe((response) => {
        _.each(response.results, (d) => {
          d['distance'] = this.efoGoogle.distFrom(
            ypDealer.latitude,
            ypDealer.longitude,
            d.geometry.location.lat,
            d.geometry.location.lng,
          );
        });
        let streetNumber = ypDealer.address1.split(' ')[0];
        ypDealer.googleResult = _.find(response.results, function (d) {
          return d.vicinity.indexOf(streetNumber) == 0;
        });
        ypDealer.googleRating = ypDealer.googleResult.rating;
        ypDealer.googleTotalUserRatings =
          ypDealer.googleResult.user_ratings_total;
        //by distance
        //ypDealer.googleResult = _.head(_.sortBy(response.results, 'distance'));
        if (
          _.has(ypDealer, 'googleResult.photos') &&
          ypDealer.googleResult.photos.length > 0
        ) {
          ypDealer.dealerPhotoUrl =
            'https://maps.googleapis.com/maps/api/place/photo?photoreference=' +
            ypDealer.googleResult.photos[0].photo_reference +
            '&sensor=false&maxheight=240&maxwidth=640&key=AIzaSyAzRlpb4MbISc_8JRIF8TIqgsrQEjOdv14';
        }
        if (_.isFunction(callback)) {
          callback(null, ypDealer);
        }
      });
  }
  getZipData(zipCode, callback?): void {
    this.efoYp.getZipData({ zip: zipCode }).subscribe((results) => {
      if (_.isFunction(callback)) {
        callback(null, _.sortBy(results, 'distance'));
      }
    });
  }

  //POST data
  saveDealer(dealer, dealer$, callback): void {
    dealer.website = dealer.dealer_info.website;
    dealer.state = dealer.dealer_info.state;
    if (_.has(dealer, 'dealer_uuid')) {
      dealer.dealer_info = _.extend({}, dealer.dealer_info);
      Object.assign(dealer$, dealer);
      this.http
        .put(`${environment.nestElevationApiUrl}/elevate/dealer`, dealer)
        .subscribe((response: any) => {
          callback(null, { dealer: dealer, dealer$: dealer$ });
        });
    } else {
      dealer.dealer_uuid = this.efoLd.guidLower();
      if (dealer.account_num != '0') {
        //creating a new local
        dealer.account_num = this.makeProspectAccountNum();
      }
      this.http
        .post(`${environment.nestElevationApiUrl}/elevate/dealer`, dealer)
        .subscribe((response: any) => {
          //this.go('/msop/customer/'+dealer.account_num);
          callback(null, { dealer: dealer, dealer$: dealer$ });
        });
    }
    //this.dealer.put();
  }
  saveWebsiteExtractor(website_extractor, callback) {
    this.efoElevate
      .websiteExtractors(
        _.pick(website_extractor, [
          'dealer_uuid',
          'website_extractor_uuid',
          'website',
        ]),
      )
      .subscribe((response) => {
        if (response.length == 0) {
          this.efoElevate
            .updateWebsiteExtractors(website_extractor)
            .subscribe((rs) => {
              let websiteExtractors = rs;
              callback(null, response);
            });
        }
      });
  }
}
